import Button from '@material-ui/core/Button'
import React, { useEffect, useState } from 'react'
import { deviceType, isMobile, isTablet } from 'react-device-detect'
import WebFooter from '../../source/WebScreen/WebFooter'
import './Login.css'
import styles from './LoginForm.module.css'

const ForgotPasswordForm = props => {
  const [defaultValue, setDefaultValue] = useState('')

  useEffect(() => {}, [])

  const handleSendVerification = e => {
    if (e) {
      e.preventDefault()
    }
    props.handleSendVerification()
  }

            
            
  const handleKeyUp = e => {
    if (e.keyCode == 9) {
      e.preventDefault()
          }
  }

  return (
    <div>
      {deviceType == 'browser' && (isMobile == false || isMobile == 'false') && (isTablet == false || isTablet == 'false') ? (
        <div className="loginformnew">
          <div className={styles.loginform_flex_container}>
            {/* Left Panel: Image and Footer */}
            <div className={styles.loginform_left_panel}>
              <div className={styles.loginform_image_wrapper}>
                <img src={require('../../source/Images/Banner/welcome_image_desktop.jpg')} className={styles.loginform_main_image} alt="welcome" />
              </div>
              <div className={styles.loginform_footer}>
                Copyright © 2019-2026 Universal Health Fellowship. All rights reserved. | Powered by CarynHealth<br />
                Version 6.1.0
              </div>
            </div>
            {/* Right Panel: Form */}
            <div className={styles.loginform_right_panel}>
              <form onSubmit={handleSendVerification} className={styles.loginform_form_wrapper}>
                <img src={require('../../source/Images/Banner/logo.png')} className={styles.login_uhs_logo} alt="logo" />
                <div className={styles.login_input_container}>
                  <input
                    className={["login_input_username", styles.loginform_input].join(' ')}
                    type="email"
                    name="email"
                    pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$"
                    required
                    placeholder="Enter your email"
                    onChange={props.handleChange}
                    onKeyDown={handleKeyUp}
                  />

                  <Button type="submit" className={["login_button", styles.loginform_button].join(' ')}>
                    RESET MY PASSWORD
                  </Button>
                </div>
                <div className={styles.login_bottom_text}>
                  <div className={styles.forgot_password_header}>
                    <div className={styles.forgot_password_title}>Forgot your password?</div>
                    <div className={styles.forgot_password_subtitle}>Enter your Email and we will send a message to reset your password.</div>
                  </div>
                  <div className={styles.login_bottom_subtext}>
                    Go back to
                    <span className={styles.login_plese_text} onClick={() => props.gotoLoginScreen()}>
                      {' '}Sign In
                    </span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div class="loginmobile">
          {/* <div class="loginmobile_header"> */}
            {/* <MenuIcon style={{ color: '#ffffff', marginRight: '20px' }} /> */}
            {/* <div class="loginmobile_header_text">Member Portal</div> */}
          {/* </div> */}

          <div className="loginmobile_container">
            <form onSubmit={handleSendVerification}>
              <div className="loginmobile_image_container" style={{paddingTop:'30px'}}>
                <img src={require('../../source/Images/Banner/welcome_image_desktop.jpg')} className="loginmobile_banner" />
                <img src={require('../../source/Images/Banner/logo.png')} className="loginmobile_logo" />
              </div>

              <div class="loginmobile_input_container">
                <input
                  type="email"
                  name="email"
                  pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$"
                  required
                  placeholder="Enter your email"
                                    class="loginmobile_input_username"
                  onChange={props.handleChange}
                />

                <Button type="submit" variant="contained" color="" class="loginmobile_button">
                  RESET MY PASSWORD
                </Button>
              </div>

              <div class="loginmobile_bottom_text">
                <div class="loginmobile_text_blue">Forgot your password?</div>
                <div class="forgotmobile_text_details">
                  <div>Enter your Email and we will send a message to</div>
                  <div>reset your password</div>
                </div>
                <div class="loginmobile_bottom_subtext2">
                  <div>
                    Go to
                    <span class="loginmobile_please_check" onClick={() => props.gotoLoginScreen()}>
                      {' '}
                      Sign In
                    </span>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}

export default ForgotPasswordForm





